import { TEXT_MESSAGES_ENABLED, TWILIO_ENDPOINT } from '../config/messaging';
import { NOTIFICATIONS_ENABLED } from '../config/notifications';

// Fills {{placeholders}} from a values object. Anything not supplied is left as-is,
// so missingPlaceholders() can catch it before a text goes out.
export const fillTemplate = (text, values = {}) =>
  (text || '').replace(/\{\{\s*([a-zA-Z_0-9]+)\s*\}\}/g, (match, key) =>
    values[key] !== undefined && values[key] !== null && values[key] !== '' ? String(values[key]) : match
  );

export const missingPlaceholders = (text) => [...new Set((text || '').match(/\{\{[^}]+\}\}/g) || [])];

// "Jane", "Jane and John", or "Jane, John, and Mike" from the client first names on the transaction.
export const clientGreeting = (firstNames = []) => {
  const names = firstNames.map((n) => (n || '').trim()).filter(Boolean);
  if (names.length === 0) return '';
  if (names.length === 1) return names[0];
  if (names.length === 2) return `${names[0]} and ${names[1]}`;
  return `${names.slice(0, -1).join(', ')}, and ${names[names.length - 1]}`;
};

// Texts can only go out when both switches are on.
export const textSendingReady = () => TEXT_MESSAGES_ENABLED && NOTIFICATIONS_ENABLED;

// Returns the reason a text was not sent, so the screen can show the right message.
export const sendText = async ({ to, body }) => {
  if (!NOTIFICATIONS_ENABLED) return { sent: false, reason: 'sending_disabled' };
  if (!TEXT_MESSAGES_ENABLED) return { sent: false, reason: 'twilio_not_connected' };
  if (!to) return { sent: false, reason: 'no_phone' };
  const leftover = missingPlaceholders(body);
  if (leftover.length) return { sent: false, reason: 'missing_fields', fields: leftover };
  try {
    const res = await fetch(TWILIO_ENDPOINT, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ to, body }),
    });
    return res.ok ? { sent: true } : { sent: false, reason: 'send_failed' };
  } catch (err) {
    console.error('Text send failed:', err);
    return { sent: false, reason: 'send_failed' };
  }
};
